import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  SortableContainer,
  SortableElement,
  sortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import Pagination from "react-js-pagination";
import PollIcon, { HEADING_POLL } from "PollIcon";
import NoContent, { NO_POLL } from "NoContent";
import { activePolls, fetchPolls, updatePollList } from "PollAction";
import { screenHeightLeftFromTop } from "Constants";
import PollItem from "./poll-list-item";
import AddPoll from "./add-poll";
import ExportPolls from "ExportPolls";
import DowloadPollResults from "./dowloadpollresults";
import ExportPollsExcelBtn from "./downloadpollcsv";
import BroadCastLivePolls from "./broadcast-live-polls"; // Modal contain embadded page
import Loader from "Loader";
import LocaleStrings from "Languages";

// userd for sort content list
const DragHandle = sortableHandle(({}) => (
  <span className="drag-icon" style={{ cursor: "move" }}>
    <i className="fa fa-bars mx-6" aria-hidden="true"></i>
  </span>
));

const SortableItem = SortableElement(
  ({
    value,
    pageDataLength,
    currentPage,
    pagination,
    activeArchived,
    select,
  }) => (
    <PollItem
      dragData={<DragHandle />}
      key={value.id}
      poll={value}
      pageDataLength={pageDataLength}
      currentPage={currentPage}
      pagination={pagination}
      activeArchived={activeArchived}
      select={select}
    />
  )
);

const SortableList = SortableContainer(
  ({
    items,
    pageDataLength,
    currentPage,
    pagination,
    activeArchived,
    select,
  }) => {
    return (
      <div>
        {items.map((value, index) => {
          return (
            <SortableItem
              key={`item-${index}`}
              index={index}
              value={value}
              pageDataLength={pageDataLength}
              currentPage={currentPage}
              pagination={pagination}
              activeArchived={activeArchived}
              select={select}
            />
          );
        })}
      </div>
    );
  }
);

class Poll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      activeCount: 0,
      archiveCount: 0,
      // pageLoader: false,
      loading: true,
      desc: LocaleStrings.preparingPolls,
    };
  }

  componentDidMount() {
    this.props.activePolls("active");
    let select =
      this.props.selectPollListType && this.props.selectPollListType.select
        ? this.props.selectPollListType.select
        : "active";
    this.props.fetchPolls(
      this.props.session,
      select,
      this.props.selectedSession,
      0,
      (callback) => {
        this.setState({ loading: false });
      }
    );
  }

  renderPollList() {
    let pageDataLength =
      this.props.pollList && this.props.pollList.resource
        ? this.props.pollList.resource.length
        : 0;
    let select =
      this.props.selectPollListType && this.props.selectPollListType.select
        ? this.props.selectPollListType.select
        : "active";
    let { pageNumber } = this.state;
    return _.map(this.props.pollList.resource, (poll) => {
      return (
        <PollItem
          key={poll.id}
          poll={poll}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
          pagination={this.paginationCallback}
          activeArchived={this.activeArchived}
          select={select}
        />
      );
    });
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    // var arrAvailable = this.props.availableFeatures;
    var arrAvailable = this.props.pollList.resource;
    arrAvailable = arrayMove(arrAvailable, oldIndex, newIndex);
    let select =
      this.props.selectPollListType && this.props.selectPollListType.select
        ? this.props.selectPollListType.select
        : "active";
    var newArrAvailable = [];

    if (select === "active") {
      this.setState({ activeCount: arrAvailable.length });
      arrAvailable.map((value, index) => {
        newArrAvailable.push({ ...value, displayorder: index + 1 });
      });
    } else {
      this.setState({ archiveCount: arrAvailable.length });
      let count = this.state.activeCount + 1;
      arrAvailable.map((value, index) => {
        newArrAvailable.push({ ...value, displayorder: index + count });
      });
    }
    // this.setState({ pageLoader: true });
    this.props.updatePollList(this.props.session, newArrAvailable, (res) => {
      if (res.success) {
        let select =
          this.props.selectPollListType && this.props.selectPollListType.select
            ? this.props.selectPollListType.select
            : "active";
        this.props.fetchPolls(
          this.props.session,
          select,
          this.props.selectedSession,
          this.state.pageNumber,
          (callback) => {
            if (callback.success) {
              // this.setState({ pageLoader: false });
            }
          }
        );
      } else {
      }
    });
  };

  activeArchived = () => {};

  updatePageNumber = (pageNumber) => {
    this.setState({ ...this.state, pageNumber });
  };

  pollAdditionCallback = () => {
    this.paginationCallback(this.state.pageNumber);
  };

  paginationCallback = (pageNumber) => {
    let select =
      this.props.selectPollListType && this.props.selectPollListType.select
        ? this.props.selectPollListType.select
        : "active";
    this.props.fetchPolls(
      this.props.session,
      select,
      this.props.selectedSession,
      pageNumber,
      (callback) => {}
    );

    this.setState({ ...this.state, pageNumber });
  };

  exportPolls = (JSONData, ShowLabel) => {
    this.JSONToCSVConvertor(JSONData, ShowLabel);
  };

  JSONToCSVConvertor(JSONData, ShowLabel) {
    // //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    // var arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

    // var CSV = "";

    // //This condition will generate the Label/Header
    // if (ShowLabel) {
    //   var row = "Poll Id\n";
    //   _.map(arrData, (item) => {
    //     row += item.pollid + "\n";
    //   });
    //   row = row.slice(0, -1);

    //   //append Label row with line break
    //   CSV += row + "\r\n";

    // }

    // if (CSV == "") {
    //   alert("Invalid data");
    //   return;
    // }

    // //Generate a file name
    // var fileName = "Polls";

    // //Initialize file format you want csv or xls
    // var uri = "data:text/csv;charset=utf-8," + escape(CSV);

    // // Now the little tricky part.
    // // you can use either>> window.open(uri);
    // // but this will not work in some browsers
    // // or you will not get the correct file extension

    // //this trick will generate a temp <a /> tag
    // var link = document.createElement("a");
    // link.href = uri;

    // //set the visibility hidden so it will not effect on your web-layout
    // link.style = "visibility:hidden";
    // link.download = fileName + ".csv";

    // //this part will append the anchor tag and remove it after automatic click
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);

    var XLSX = require("xlsx");
    /* Create a new empty workbook, then add the worksheet */
    let wb = XLSX.utils.book_new();
    _.map(JSONData, (item, index) => {
      /* Create a worksheet */
      var ws = XLSX.utils.json_to_sheet(item);
      // var ws1 = XLSX.utils.json_to_sheet(JSONData['F2(149426)']);

      var sheetName = index.replace(/[\/\\:\[\]*?]/g, "_"); // Sheet name cannot contain ': \ / ? * [ ]' so replacing with '_' and also can not contain more than 31 chars
      if (sheetName.length > 30) {
        sheetName = sheetName.substr(0, 28) + "...";
      }

      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      // XLSX.utils.book_append_sheet(wb, ws1, "F2(149426)");
    });

    /* Generate xlsx files */
    XLSX.writeFile(wb, "polls.xlsx");
  }

  /**
   * =============================================================================================
   */

  render() {
    let pollList = this.props.pollList.resource;
    let pageDataLength =
      this.props.pollList && this.props.pollList.resource
        ? this.props.pollList.resource.length
        : 0;
    let select =
      this.props.selectPollListType && this.props.selectPollListType.select
        ? this.props.selectPollListType.select
        : "active";
    let {
      pageNumber,
      // pageLoader
    } = this.state;
    let { deviceSize, selectedSession } = this.props;

    var classCustom = "";
    // if (pageLoader) {
    //   // classCustom = "page-loading";
    // }

    return (
      <div>
        <div className="content-header-bar">
          <div className="vertical-align-center gap-1 flex-grow-1">
            <PollIcon
              heading={HEADING_POLL}
              updatePageNumber={this.updatePageNumber}
            />
          </div>

          <ul className="header-buttons">
            <li>
              <AddPoll
                select={select}
                finishOperationsCallback={this.pollAdditionCallback}
                history={this.props.history}
              />
            </li>
            <li>
              {/* <ExportPolls JSONToCSVConvertor={this.exportPolls} /> OLD CODE */}
              <ExportPollsExcelBtn JSONToCSVConvertor={this.exportPolls} />
            </li>
            <li>
              <DowloadPollResults />
            </li>
          </ul>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{ height: deviceSize.height - screenHeightLeftFromTop }}
        >
          {this.state.loading ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">{this.state.desc}</div>
            </div>
          ) : (
            <>
              {pollList && pollList.length > 0 ? (
                <>
                  <div
                    className="row mb-10"
                    style={{ fontWeight: 700, color: "rgb(195,203,223)" }}
                  >
                    <div className="col-sm-6 col-lg-8">
                      {LocaleStrings.polls_qa_table_list_polls}
                    </div>
                    <div className="col-sm-2 col-lg-1">
                      {LocaleStrings.polls_qa_table_poll_analytics}
                    </div>
                    <div className="col-sm-2 col-lg-1">
                      {LocaleStrings.polls_qa_table_poll_result}
                    </div>
                    <div
                      className="col-sm-2 col-lg-1"
                      style={{ paddingLeft: 30 }}
                    >
                      {LocaleStrings.polls_qa_table_list_action}
                    </div>
                  </div>
                  {/* <div style={{ backfaceVisibility: 'hidden', willChange: 'transform', userSelect: 'none', WebkitUserSelect: 'none', titleBarStyle: 'hidden' }}>
                                            <SortableList items={this.props.pollList.resource} onSortEnd={this.onSortEnd} pressDelay={200} axis='y' lockAxis='y' pageDataLength={pageDataLength} currentPage={pageNumber} pagination={this.paginationCallback} activeArchived={this.activeArchived} select={select} />
                                        </div>
                                    </div> */}

                  <div className="row">
                    <div
                      className={`col-md-12 ${classCustom}`}
                      style={{
                        backgroundColor: "#ffffff",
                        backfaceVisibility: "hidden",
                        willChange: "transform",
                        userSelect: "none",
                        WebkitUserSelect: "none",
                        titleBarStyle: "hidden",
                      }}
                    >
                      {/* {this.renderPollList()} */}
                      <SortableList
                        useDragHandle
                        items={this.props.pollList.resource}
                        onSortEnd={this.onSortEnd}
                        // pressDelay={200}
                        axis="y"
                        lockAxis="y"
                        pageDataLength={pageDataLength}
                        currentPage={pageNumber}
                        pagination={this.paginationCallback}
                        activeArchived={this.activeArchived}
                        select={select}
                      />
                    </div>
                  </div>

                  {this.props.pollList.count > 50 ? (
                    <Pagination
                      activePage={this.state.pageNumber}
                      itemsCountPerPage={50}
                      totalItemsCount={this.props.pollList.count}
                      pageRangeDisplayed={10}
                      onChange={this.paginationCallback}
                      style={{ float: "right" }}
                    />
                  ) : (
                    ""
                  )}
                </>
              ) : (
                <NoContent contentType={NO_POLL} />
              )}
            </>
          )}
        </div>
        <BroadCastLivePolls selectedSession={selectedSession} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    pollList: state.pollList,
    selectPollListType: state.selectPollListType,
    selectedSession: state.selectedSession.resource,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {
  activePolls,
  fetchPolls,
  updatePollList,
})(Poll);
